import React from "react";
import { Button, Form } from "react-bootstrap";
// import { AdvanceFilters } from "./AdvanceFilters";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import FASvgIcon from "./FASvgIcon";
import SvgIcon from "./SvgIcon";

type Props = {
  filtersForm: JSX.Element;
  isFilterOpen?: boolean;
  showSearchFilter?: boolean;
  showClearFilter?: boolean;
  searchPlaceholder?: string;
  searchValue?: string;
  showAdvFilters?: boolean;
  searchOnChange?: (t: string) => void;
  onClickClearBtn?: () => void;
  onClickShowFilters?: () => void;
  onClickHideFilters?: () => void;
  onClickSearchBtn?: () => void;
};

const PageFilterWrap: React.FC<Props> = (props: Props) => {
  const {
    filtersForm,
    showSearchFilter = true,
    showAdvFilters = true,
    showClearFilter = false,
    searchPlaceholder = "Search...",
    searchValue,
    searchOnChange,
    isFilterOpen = false,
    onClickClearBtn,
    onClickShowFilters,
    onClickHideFilters,
    onClickSearchBtn
  } = props;

  return (
    <>
      {showSearchFilter ? (
        <Form
          className="search-field-form"
          onSubmit={(event) => {
            event.preventDefault();
            if (onClickSearchBtn) {
              onClickSearchBtn();
            }
          }}
        >
          <Form.Group className="form-group search-field-wrap">
            <Form.Control
              size="lg"
              type="text"
              id="search_query"
              placeholder={searchPlaceholder}
              value={searchValue}
              onChange={(event) => (searchOnChange ? searchOnChange(event.target.value) : null)}
            />
            <Button
              variant="transparent"
              className="icon-only"
              onClick={() => (onClickSearchBtn ? onClickSearchBtn() : null)}
            >
              <FASvgIcon icon={faSearch} />
            </Button>
          </Form.Group>
        </Form>
      ) : null}

      {(showClearFilter || showAdvFilters) && (
        <div className="filter-btns-wrap">
          {showClearFilter && (
            <Button variant="link" onClick={onClickClearBtn}>
              Clear Filters
            </Button>
          )}
          {showAdvFilters ? (
            <Button variant="outline-secondary" className="filter-btn" onClick={onClickShowFilters}>
              <SvgIcon icon="filters-icon" />
              Advance Filters
            </Button>
          ) : null}
        </div>
      )}

      {/* <AdvanceFilters
        isFilterOpen={isFilterOpen}
        hideAdvFilters={onClickHideFilters ? onClickHideFilters : () => null}
        filterForm={filtersForm}
      /> */}
    </>
  );
};

export default PageFilterWrap;
